function normalizeEnvironment(value) {
  return String(value || '').trim().toLowerCase();
}

export function getRuntimeEnvironment() {
  return normalizeEnvironment(process.env.REACT_APP_RUNTIME_ENVIRONMENT || process.env.NODE_ENV);
}

export function isLocalDevelopmentRuntime() {
  const environment = getRuntimeEnvironment();
  return environment === 'local' || environment === 'dev' || environment === 'development';
}

export function isTestRuntime() {
  return getRuntimeEnvironment() === 'test';
}

export function isNonLocalRuntime() {
  return !isLocalDevelopmentRuntime() && !isTestRuntime();
}

export function allowLocalDocumentsSnapshotFallback() {
  return (
    (isLocalDevelopmentRuntime() || isTestRuntime()) &&
    normalizeEnvironment(process.env.REACT_APP_ALLOW_LOCAL_DOCUMENTS_SNAPSHOT) === 'true'
  );
}
